const jobsFilterParameters = new Set([
  'keywords',
  'location',
  'locations',
  'sectors',
  'disciplines',
  'office_type',
  'job_type',
  'contract_type',
  'daily_rate_range',
  'annual_salary_range',
  'daily_rate_min',
  'daily_rate_max',
  'annual_salary_min',
  'annual_salary_max',
  'salary_min_day',
  'salary_max_day',
  'salary_min_annum',
  'salary_max_annum',
  'salary_type',
  'salary_min',
  'salary_max',
  'internal',
  'page',
]);

const parameterBaseName = (parameter) => parameter.replace(/\[\d*\]$/, '');

export const clearJobsFilterQueryParameters = (url) => {
  Array.from(url.searchParams.keys()).forEach((parameter) => {
    if (jobsFilterParameters.has(parameterBaseName(parameter))) {
      url.searchParams.delete(parameter);
    }
  });

  return url;
};

export const appendJobsSectionFilterQueryParameters = (url, filters) => {
  Object.entries(filters).forEach(([name, values]) => {
    const filterValues = Array.isArray(values) ? values : [values];
    const parameter = name === 'sectors' && filterValues.length === 1
      ? name
      : `${name}[]`;

    filterValues.forEach((value) => url.searchParams.append(parameter, value));
  });

  return url;
};

export const updateJobsSearchQuery = (url, entries, internal = '0') => {
  clearJobsFilterQueryParameters(url);
  for (const [name, value] of entries) {
    if (jobsFilterParameters.has(parameterBaseName(name)) && name !== 'page' && String(value).trim() !== '') {
      url.searchParams.append(name, value);
    }
  }
  if (internal === '1' && !url.searchParams.has('internal')) {
    url.searchParams.set('internal', '1');
  }
  return url;
};
